module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAAAXNSR0IArs4c6QAAAStJREFUSEtjZGBgYNA29jrB8P+/MIhNC8DHzmPOCDJYx8jz5X8GBjFaWAIyk42bR2zgLGJhYjb/+5/lLaW++8/w8xTDfwYhnD4CefP84dWvKbVIx8jz1X8GBtHBY5G+qa/2379/TmLzGQsrs+GFk1tu4/M10T7SNfbS/ff//yVshjEzsWpcOrPp5tCyqKGhgWndsbuc2Fx9ceeib4yMjP+p4qPQ0FC2m4/+EpWJgzz1njU0NPxDtpjoONI28bRm+MdwhJhkzsHIKXX27Lrng9siHTMvE4a//9cT4yMmdg7jS8fWvyLLR8RYQJXEMGoReggQnbxpHnQMDAwPGBkZ/lJq0f//jIoMDP+ZBr6GpdQn2PTD2wyGVl7yv3+ysdDCEpCZIb4G98GNE3oAAPAv5SwFX1NFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_sid.png
// module id = 1KXd
// module chunks = 1